import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4e1fb5b4 from 'nuxt_plugin_plugin_4e1fb5b4' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_6a8a179c from 'nuxt_plugin_plugin_6a8a179c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_pluginutils_800a669e from 'nuxt_plugin_pluginutils_800a669e' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_627af1bc from 'nuxt_plugin_pluginrouting_627af1bc' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_67ddb333 from 'nuxt_plugin_pluginmain_67ddb333' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_image_70f66876 from 'nuxt_plugin_image_70f66876' // Source: ./image.js (mode: 'all')
import nuxt_plugin_00monkeypatch_11b7456f from 'nuxt_plugin_00monkeypatch_11b7456f' // Source: ../../../plugins/00-monkeypatch.ts (mode: 'all')
import nuxt_plugin_01initImmer_9c604706 from 'nuxt_plugin_01initImmer_9c604706' // Source: ../../../plugins/01-initImmer.ts (mode: 'all')
import nuxt_plugin_10initApp_201ca754 from 'nuxt_plugin_10initApp_201ca754' // Source: ../../../plugins/10-initApp.ts (mode: 'all')
import nuxt_plugin_30initComponentPlugins_44c9ceec from 'nuxt_plugin_30initComponentPlugins_44c9ceec' // Source: ../../../plugins/30-initComponentPlugins.js (mode: 'all')
import nuxt_plugin_meta_4c0b29ae from 'nuxt_plugin_meta_4c0b29ae' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"HYRE TALENTS | Starte bei Top-Startups Jobs im Sales durch","titleTemplate":"%s | HYRE TALENTS","script":[{"async":true,"id":"Cookiebot","src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js","data-cbid":"a54882da-7d88-4759-8fee-b111a12ae00f","type":"text\u002Fjavascript"},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fassets.calendly.com\u002Fassets\u002Fexternal\u002Fwidget.js"},{"type":"text\u002Fplain","innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-KNG2SNM');","data-cookieconsent":"marketing"},{"type":"text\u002Fplain","innerHTML":"(function(c,l,a,r,i,t,y){\nc[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src=\"https:\u002F\u002Fwww.clarity.ms\u002Ftag\u002F\"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, \"clarity\", \"script\", \"ec6i9qjfqv\");","data-cookieconsent":"statistics"},{"type":"text\u002Fplain","innerHTML":"_linkedin_partner_id = \"4262545\"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id);","data-cookieconsent":"marketing"},{"type":"text\u002Fplain","innerHTML":"(function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]} var s = document.getElementsByTagName(\"script\")[0]; var b = document.createElement(\"script\"); b.type = \"text\u002Fjavascript\";b.async = true; b.src = \"https:\u002F\u002Fsnap.licdn.com\u002Fli.lms-analytics\u002Finsight.min.js\"; s.parentNode.insertBefore(b, s);})(window.lintrk);","data-cookieconsent":"marketing"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"user-scalable=no, width=device-width, height=device-height"},{"hid":"description","name":"description","content":"Bewerbung mit einem Klick in der HYRE App. Baue dein Junior Sales Team mit der besten Auswahl an qualifizierten und verfügbaren Sales Talenten auf."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Fassets.calendly.com\u002Fassets\u002Fexternal\u002Fwidget.css"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4e1fb5b4 === 'function') {
    await nuxt_plugin_plugin_4e1fb5b4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_6a8a179c === 'function') {
    await nuxt_plugin_plugin_6a8a179c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_800a669e === 'function') {
    await nuxt_plugin_pluginutils_800a669e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_627af1bc === 'function') {
    await nuxt_plugin_pluginrouting_627af1bc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_67ddb333 === 'function') {
    await nuxt_plugin_pluginmain_67ddb333(app.context, inject)
  }

  if (typeof nuxt_plugin_image_70f66876 === 'function') {
    await nuxt_plugin_image_70f66876(app.context, inject)
  }

  if (typeof nuxt_plugin_00monkeypatch_11b7456f === 'function') {
    await nuxt_plugin_00monkeypatch_11b7456f(app.context, inject)
  }

  if (typeof nuxt_plugin_01initImmer_9c604706 === 'function') {
    await nuxt_plugin_01initImmer_9c604706(app.context, inject)
  }

  if (typeof nuxt_plugin_10initApp_201ca754 === 'function') {
    await nuxt_plugin_10initApp_201ca754(app.context, inject)
  }

  if (typeof nuxt_plugin_30initComponentPlugins_44c9ceec === 'function') {
    await nuxt_plugin_30initComponentPlugins_44c9ceec(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_4c0b29ae === 'function') {
    await nuxt_plugin_meta_4c0b29ae(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
